import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchGet, fetchPost } from '../../../utils/request';
import { GET_LENDER_AGREEMENT, UDPDATE_TERMS } from '../../../utils/urls';
import { getLenderAgreementSuccess, getLenderAgreementError, updateAgreementError, updateAgreementSuccess } from  './laActions';
import {LENDER_AGREEMENT, UPDATE_AGREEMENT} from '../actionType';
import { setAuthToken } from '../../../utils/localStorage';

function* lenderAgreement():any {
    try {
        const resp = yield call(fetchGet, GET_LENDER_AGREEMENT);
        if(resp.error){
            yield put(getLenderAgreementError(resp.error));
            return false;
        }
        yield put(getLenderAgreementSuccess(resp));
        return true;
    } catch (error) {
        yield put(getLenderAgreementError(error));
    }
}

function* updateAgreement():any {
    try {
        const resp = yield call(fetchPost, UDPDATE_TERMS, {});
        if (resp?.status && resp?.results?.client_token) {
            yield setAuthToken(resp?.results?.client_token);
            // yield put(getPersonalInfoSuccess(response));
            yield put(updateAgreementSuccess(resp));
            return true;
        }
        if(resp.error){
            yield put(updateAgreementError(resp.error));
            return false;
        }
        // yield put(updateAgreementSuccess(resp));
        // return true;
    } catch (error) {
        yield put(updateAgreementError("Internal Server Error"));
    }
}

export default function* lenderSaga() {
    yield all([
        takeLatest(LENDER_AGREEMENT, lenderAgreement),
        takeLatest(UPDATE_AGREEMENT, updateAgreement)    
    ])
}